import { render, staticRenderFns } from "./addProductGroup.vue?vue&type=template&id=10581179"
import script from "./addProductGroup.vue?vue&type=script&lang=js"
export * from "./addProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports